import { bl_pos_terminal_drawer_txn_line_RowClass } from '../../../dbschema';
import { bl_pos_terminal_drawer_txn_hdr_RowClass } from '../../../dbschema/bl_pos_terminal_drawer_txn_hdr.model';
import {BaseContainerModel} from '../../base-container.model';


export class PosTerminalDrawerTxnContainerModel extends BaseContainerModel {
  bl_pos_terminal_drawer_txn_hdr: bl_pos_terminal_drawer_txn_hdr_RowClass = new bl_pos_terminal_drawer_txn_hdr_RowClass();
  bl_pos_terminal_drawer_txn_line: bl_pos_terminal_drawer_txn_line_RowClass[] = [];
}
